export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const BASE_URL = process.env.REACT_APP_BASE_URL
export const UPLOAD_URL = `${BASE_URL}/upload`
export const SUPPLIER_MIGRATION_URL = `${BASE_URL}/fbz-migration`
export const DEFAULT_PAGE_SIZE = 20
